import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { coursePostFlrstTestAuthorization } from 'dsoapi';

const CoursePageExamDirections = () => {
  const { userCourseEnrollmentId } = useParams();
  const navigate = useNavigate();
  const [isStarting, setIsStarting] = useState(false);
  const [error, setError] = useState('');

  const handleStartExam = async () => {
    setIsStarting(true);
    setError('');

    try {
      console.log('Calling coursePostFlrstTestAuthorization...');
      const resp = await coursePostFlrstTestAuthorization(
        userCourseEnrollmentId
      );
      const response = resp?.data?.testAuthorizationResponse;
      console.log('Test authorization response:', response);

      const url = response?.webTestURL;

      if (url) {
        // Successfully authorized test, navigate to the road sign test page
        navigate(`/floridaroadsign/${userCourseEnrollmentId}`);
      } else if (response?.error?.message) {
        setError(response.error.message);
        setIsStarting(false);
      } else {
        setError('Failed to authorize test. Please try again.');
        setIsStarting(false);
      }
    } catch (error) {
      console.error('Error authorizing test:', error);
      setError('Error starting exam. Please try again.');
      setIsStarting(false);
    }
  };

  return (
    <div className="ui container" style={{ marginTop: '2em' }}>
      <h1 style={{ textAlign: 'center' }}>
        <strong>Florida Class E Knowledge Exam Instructions</strong>
      </h1>

      <h3 style={{ textAlign: 'center' }}>
        <strong>Read Everything Carefully Before Starting The Exam</strong>
      </h3>

      {error && <div className="ui error message">{error}</div>}

      <p>
        The Florida Class E Knowledge Exam consists of{' '}
        <strong>50 multiple-choice questions</strong>. To pass, you must
        correctly answer <strong>at least 40 questions (80%)</strong>. If a
        passing score becomes unattainable due to too many incorrect answers,
        the exam will automatically end.
      </p>

      <p>
        You are allowed <strong>up to three (3) attempts</strong> to pass the
        exam online. If you do not pass on your first or second attempt, you may
        retake the exam; however, a <strong>$20 retesting fee</strong>, set by
        the Florida DHSMV, will apply to both the{' '}
        <strong>second and third attempts</strong>.
      </p>

      <p>
        Each exam attempt has a <strong>60-minute time limit</strong>.<br />
        Once you begin the exam, it must be{' '}
        <strong>completed in one session</strong>. Do{' '}
        <strong>not log out</strong>, close your browser, or leave the exam
        page, or the attempt could be marked as{' '}
        <strong>failed/incomplete</strong>.
      </p>

      <h3 style={{ textAlign: 'center' }}>
        <strong>Important Reminders Before Starting</strong>
      </h3>

      <ul className="ui list">
        <li>
          <strong>3-Minute Question Timer</strong>:<br />
          Each question must be answered or skipped within{' '}
          <strong>3 minutes</strong>, or it will{' '}
          <strong>automatically fail</strong>. This is a{' '}
          <strong>state-mandated rule</strong>, and there will be{' '}
          <strong>no warning</strong> before time runs out. You are responsible
          for keeping track of your time.
        </li>
        <li>
          <strong>Single Tab Only</strong>:<br />
          You must have <strong>only one browser tab open</strong>—the tab with
          the exam. Opening additional tabs or navigating away from the exam may
          cause it to malfunction or result in an automatic fail. For best
          results, remain on the exam tab throughout the entire session.
        </li>
        <li>
          <strong>One Device Only</strong>:<br />
          You <strong>must complete the exam on the same computer</strong> you
          started it on. Switching devices during the exam is not permitted. The
          State requires this exam to be taken on a desktop or laptop computer.
          Using a tablet or smartphone could result in an automatic exam
          failure.
        </li>
        <li>
          <strong>After You Pass</strong>:<br />
          Once you pass, the screen will display:
          <br />
          <em>
            "Please select exit to close this window and notify the testing
            provider."
          </em>
          <br />
          <strong>No further action is required</strong>—you do{' '}
          <strong>not</strong> need to notify the provider. All completions are
          automatically recorded.
        </li>
      </ul>

      <h3 style={{ textAlign: 'center' }}>
        <strong>Ready to Begin?</strong>
      </h3>

      <p style={{ textAlign: 'center', color: '#2285d0' }}>
        Click the button below <strong>ONLY WHEN YOU ARE FULLY PREPARED</strong>{' '}
        to begin.
        <br />
        By clicking the button, you will initiate an{' '}
        <strong>official attempt</strong> of the Florida Class E Knowledge Exam.
      </p>

      <div style={{ textAlign: 'center', marginTop: '2em' }}>
        <button
          className={`ui large primary button ${isStarting ? 'loading' : ''}`}
          onClick={handleStartExam}
          disabled={isStarting}
          style={{ padding: '15px 30px', fontSize: '18px' }}
        >
          {isStarting ? 'Starting Exam...' : 'START EXAM'}
        </button>
      </div>
    </div>
  );
};

export default CoursePageExamDirections;
